/**
 * ContainerGroupRequest
 */
import React from 'react';
import { connect } from 'react-redux';

// Actions
import { requestLoadContainerGroup } from '../../../../services/containerGroups/actions';

interface Props {
    requestLoadContainerGroup: Function;
    containerGroupId: number;
}

export class ContainerGroupRequest extends React.PureComponent<Props> {
    componentDidMount() {
        const { containerGroupId } = this.props;
        this.props.requestLoadContainerGroup(containerGroupId);
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { requestLoadContainerGroup }
)(ContainerGroupRequest);
